import React from 'react';

import {
  PdfErrorContainer,
  Table,
  TableRow,
  Td,
  Th
} from 'screens/InformedConsent/Steps/YourConsent/PdfConsentViewerError.styled';

interface PdfConsentViewerErrorProps {
  pdf: string;
  isOlderBrowserError: boolean;
}

export const PdfConsentViewerError = ({ pdf, isOlderBrowserError }: PdfConsentViewerErrorProps) => {
  return (
    <PdfErrorContainer>
      <p>Unable to render the PDF.</p>
      {isOlderBrowserError ? (
        <>
          <br />
          <p>Please ensure your browser is up to date.</p>
          <br />
          <p>The table below shows the minimum supported versions.</p>
          <Table>
            <thead>
              <TableRow>
                <Th>Browser</Th>
                <Th>Version</Th>
                <Th>Release Date</Th>
              </TableRow>
            </thead>
            <tbody>
              <TableRow>
                <Td>Chrome</Td>
                <Td>v119+</Td>
                <Td>Oct 31, 2023</Td>
              </TableRow>
              <TableRow>
                <Td>Edge</Td>
                <Td>v119+</Td>
                <Td>Nov 2, 2023</Td>
              </TableRow>
              <TableRow>
                <Td>Firefox</Td>
                <Td>v121+</Td>
                <Td>Dec 19, 2023</Td>
              </TableRow>
              <TableRow>
                <Td>Safari (incl. iOS)</Td>
                <Td>v17.4+</Td>
                <Td>Mar 5, 2024</Td>
              </TableRow>
            </tbody>
          </Table>
          <br />
          <a href={pdf} target="_blank" rel="noopener noreferrer">
            Until then, you can click here to open it in a new tab.
          </a>
        </>
      ) : (
        <a href={pdf} target="_blank" rel="noopener noreferrer">
          Clink here to open in a new tab
        </a>
      )}
    </PdfErrorContainer>
  );
};
